module.exports = __webpack_public_path__ + "e325e9f7584e1dc286f4f50413ada6a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pretzel-s.png
// module id = 2590
// module chunks = 0